import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";
import "./Navbar.css"; // ضع هنا CSS مع الميديا كويري

const Navbar = ({ cart = [], favorites = [] }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState("");

  const toggleDropdown = (menu) =>
    setActiveDropdown(activeDropdown === menu ? "" : menu);

  const dropdownMenus = [
    { title: "دورات اخرى", links: [["Dawrat", "دورات أخرى"]] },
    { title: "أبحاث", links: [["Projet", "أبحاث"]] },
    { title: "دورات لغوية", links: [["Lang", "دورات لغوية"]] },
    { title: "مهني", links: [["Mahni", "مهني"]] },
    { title: "جامعي", links: [["Jame3e", "جامعي"]] },
    {
      title: "أكادمي",
      links: [
        ["Sanwe", "ثانوي"],
        ["Mouta", "متوسط"],
        ["Trbwe", "دعم تربوي"],
      ],
    },
  ];

  return (
    <nav className="nav">
      {/* شعار الموقع */}
      <div className="logo">
        <Link to="/">
          <img
            src="https://i.postimg.cc/q7XJytC4/Logo.jpg"
            alt="Logo"
            style={{ width: "100px" }}
          />
        </Link>
      </div>

      {/* زر الهامبرغر / زر الإغلاق */}
      <button className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)}>
        {menuOpen ? <FaTimes /> : <FaBars />}
      </button>

      {/* قائمة الروابط */}
      <ul className={menuOpen ? "active" : ""} style={{ display: menuOpen ? "flex" : "" }}>
        <li>
          <Link to="/Nadawe" onClick={() => setMenuOpen(false)}>
            ندوات
          </Link>
        </li>

        {dropdownMenus.map(({ title, links }) => (
          <li key={title} className="dropdown-container">
            <span onClick={() => toggleDropdown(title)}>
              {title} ▾
            </span>
            {activeDropdown === title && (
              <ul className="dropdown">
                {links.map(([to, text]) => (
                  <li key={to}>
                    <Link to={`/${to}`} onClick={() => setMenuOpen(false)}>
                      {text}
                    </Link>
                  </li>
                ))}
              </ul>
            )}
          </li>
        ))}

        <li>
          <Link to="/" onClick={() => setMenuOpen(false)}>
            الصفحة الرئيسية
          </Link>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
